// import React, { useEffect, useState } from "react";
// import useHttp from "../../../hooks/use-http";
// import Pagination from "../../../components/Pagination";
// import { Modal as AntModal } from "antd";
// import { toast } from "react-toastify";

// const RateCardList = (props) => {
//   const { addForm, update } = props;
//   const [data, setData] = useState([]);
//   const [allData, setAllData] = useState([]);
//   const [itemsPerPage] = useState(10);
//   const [orgConfigList, setOrgConfigList] = useState([]);
//   const { sendRequest: getDataList } = useHttp();


//    const isConfigActive =
//     orgConfigList?.length > 0 && orgConfigList[0].status === 1;

//   const FillDetail = () => {
//     getDataList(
//       {
//         url: `/api/grade/?orgId=${localStorage.getItem(
//               "orgId"
//             )}`
//       },
//       (res) => {
//         if (res) {
//           setData(res);
//           setAllData(res);
//         }
//       }
//     );
//   };

//   useEffect(() => {
//     FillDetail();
//   }, [getDataList]);



  
//     const { sendRequest: getOrgConfig } = useHttp();
//     useEffect(() => {
//       getOrgConfig(
//         {
//           url: `/api/orgconfigapplications?orgId=${localStorage.getItem(
//             "orgId"
//           )}&orgConfigSettingId=16`,
//         },
//         (res) => {
//           if (res) {
//             setOrgConfigList(res);
//           }
//         }
//       );
//     }, [getOrgConfig]);

//   const [currentPage, setCurrentPage] = useState(1);
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

//   const paginate = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const { sendRequest: deleteOperation } = useHttp();

//   const handleDelete = (e, gradeId) => {
//     e.preventDefault();
//     AntModal.confirm({
//       title: "Confirm Deletion",
//       content: "Are you sure you want to delete this Rate Card detail?",
//       onOk() {
//         deleteOperation(
//           {
//             url: `/api/grade/?orgId=${localStorage.getItem(
//               "orgId"
//             )}&createdBy=${parseInt(
//               localStorage.getItem("id")
//             )}&gradeId=${gradeId}&serviceId=${serviceId}`,
//             method: "DELETE",
//           },
//           (data) => {
//             toast.success("Data Deleted Successfully");
//             FillDetail();
//           }
//         );
//       },
//       onCancel() {},
//     });
//   };

//   const handleSearch = (e) => {
//       var filetrtext = e.target.value.trim().toLowerCase();

//     var filterdata = allData.filter(
//       (item) =>
//         item.cropName.toLowerCase().includes(filetrtext) ||
//       item.cropName.toLowerCase().includes(filetrtext) ||
//         item.varietyName.toLowerCase().includes(filetrtext) ||
//         item.unitAbbreviation.toLowerCase().includes(filetrtext)
//     );

//    setData(filterdata); 
                                
// setCurrentPage(1);
//   };
//  const [canAdd, setCanAdd] = useState("none");
//   const [canEdit, setCanEdit] = useState("none");
//   const [canDelete, setCanDelete] = useState("none");
//   const [canPdf, setCanPdf] = useState("none");
//   const [canView, setCanView] = useState("none");
//   const [serviceId, setServiceId] = useState("none");

//   useEffect(() => {
//     var urlpathname = window.location.pathname;
//     var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

//     if (roleAllocation && roleAllocation.length > 0) {
//       //console.log("roleAllocation", roleAllocation);

//       var roleAllocationFilterList = roleAllocation.filter(
//         (item) => item.serviceUrl == urlpathname
//       );
//       //console.log("roleAllocationFilterList", roleAllocationFilterList);
//       if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
//         var itemselected = roleAllocationFilterList[0];

//         console.log(itemselected);

//         setServiceId(itemselected.serviceId);
        
//         if (itemselected.canAddStatus == true) {
//           setCanAdd("block");
//         }

//         if (itemselected.canEditStatus == true) {
//           setCanEdit("block");
//         }

//         if (itemselected.canDeleteStatus == true) {
//           setCanDelete("block");
//         }
//         if (itemselected.canViewStatus == true) {
//           setCanView("block");
//         }

//         if (itemselected.canPdfStatus == true) {
//           setCanPdf("block");
//         }
//         //console.log("canAdd", canAdd);
//       }
//     }
//   }, []);


//   return (
//     <>
//       <div className="content-wrapper">
//         <div className="row mx-2">
//           <div className="col-6">
//             <label className="card-title mx-2 my-3">
//               {" "}
//               &nbsp; &nbsp;Buy Back Price{" "}
//             </label>{" "}
//           </div>
//           <div className="col-4"> </div>
//           <div className="col-2">
//             <button
//               type="button"
//               className="btn  btn-primary mx-2 my-2"
//               style={{ whiteSpace: "nowrap" }}
//               onClick={() => {
//                 addForm(true);
//                 props.update(false);
//                 props.sId(serviceId || 0);
//               }}
//             >
//               Add Buy Back Price
//             </button>
//           </div>
//         </div>

//         <section className="content">
//           <div className="container-fluid">
//             <div className="row">
//               <div className="col-md-12">
//                 <div className="card">
//                   <div className="card-body">
//                     <div className="row ">
//                       <div className="col-9"> </div>
                   

//                       <div className="col-3">
//                         {" "}
//                         <input
//                           type="text"
//                           name="q"
//                           className="form-control"
//                           placeholder="Search..."
//                           onKeyUp={(e) => {
//                             handleSearch(e);
//                           }}
//                         />{" "}
//                         <br />
//                       </div>
//                     </div>
//                     <div className="row">
//                       <table className="table table-bordered text-center table-responsive">
//                         <thead>
//                           <tr>
//                             <th>Date</th>
//                             <th>Crop Name</th>
//                             {/* <th>Variety Name</th> */}
//                             <th>Quantity</th>
                             
//                             <th>{isConfigActive
//                             ? "Good (Rate/Unit)"
//                             : "Grade 1 (Rate/Unit)"}</th>
//                             <th>{isConfigActive
//                             ? "Bad (Rate/Unit)"
//                             : "Grade 2 (Rate/Unit)"}</th>
//                             {!isConfigActive
//                             ? <th>Grade 3 Rate </th>
//                             : ""}   
//                              {!isConfigActive
//                             ? <th>Grade 4 Rate </th>
//                             : ""} 
//                             {isConfigActive
//                             ? <th>Bonus Rate(Good) </th>
//                             : ""}
                            
//                              {isConfigActive
//                             ? <th>Score Limit(Good) </th>
//                             : ""}
                        
//                             <th>Currency</th>
//                             <th>Status</th>
//                             {/* <th>Edit</th> */}
//                             <th>Delete</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {currentItems &&
//                             currentItems.map((x, i) => (
//                               <tr key={i}>
//                                 <td>{x.createdDate}</td>
//                                 <td>{x.cropName}</td>
//                                 {/* <td>{x.varietyName}</td> */}
//                                 <td>{x.quantity} {x.unitAbbreviation}</td>
//                                 <td>{x.class1Rate}</td>
//                                 <td>{x.class2Rate}</td>
                                
//                                   {!isConfigActive
//                             ? <td>{x.class3Rate} </td>
//                             : ""} 

//                                   {!isConfigActive
//                             ? <td>{x.class4Rate} </td>
//                             : ""} 

//                                  {isConfigActive
//                             ? <td>{x.bonusRate} </td>
//                             : ""} 

//                                   {isConfigActive
//                             ? <td>{x.scoreLimit} </td>
//                             : ""} 

                            
//                                 <td>{localStorage.getItem("currencyCode") || ""}</td>
//                                 <td>
//                                   {x.status == 1 ? "Active" : "In-Active"}
//                                 </td>
//                                 {/* <td>
//                                   <button className="btn">
//                                     {" "}
//                                     <i className="fas fa-edit"></i>
//                                   </button>
//                                 </td> */}
//                                 <td>
//                                   <button
//                                     className="btn"
//                                     onClick={(e) => handleDelete(e, x.grade_id)}
//                                   >
//                                     {" "}
//                                     <i className="fas fa-trash"></i>
//                                   </button>
//                                 </td>
//                               </tr>
//                             ))}
//                         </tbody>

                     
//                       </table>
//                     </div>
//                   </div>
//                   {/* /.card-body */}
//                   <div className="card-footer clearfix">
//                     <Pagination
//                       totalItems={data.length}
//                       itemsPerPage={itemsPerPage}
//                       onPageChange={paginate}
//                       currentPage={currentPage}
//                       setCurrentPage={setCurrentPage}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

// export default RateCardList;


import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";

const BuyBackPriceList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getDataList } = useHttp();

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/buyBackPrice/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          const list = res.data || res;
          setData(list);
          setAllData(list);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, assessmentId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Buy Back Price detail?",
      onOk() {
        deleteOperation(
          {
            url: `/api/buyBackPrice/?orgId=${localStorage.getItem(
              "orgId"
            )}&createdBy=${parseInt(
              localStorage.getItem("id")
            )}&assessmentId=${assessmentId}&serviceId=${serviceId}`,
            method: "DELETE",
          },
          (data) => {
            toast.success("Data Deleted Successfully");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const handleSearch = (e) => {
    var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.cropName?.toLowerCase().includes(filetrtext) ||
        item.ranchName?.toLowerCase().includes(filetrtext) ||
        item.seasonName?.toLowerCase().includes(filetrtext) ||
        item.unitAbbreviation?.toLowerCase().includes(filetrtext)
    );

    setData(filterdata);
    setCurrentPage(1);
  };

  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        setServiceId(itemselected.serviceId);

        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
      }
    }
  }, []);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Buy Back Price{" "}
            </label>{" "}
          </div>
          <div className="col-4"> </div>
          <div className="col-2">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              style={{ whiteSpace: "nowrap", display: canAdd }}
              onClick={() => {
                addForm(true);
                props.update(false);
                props.sId(serviceId || 0);
              }}
            >
              Add Buy Back Price
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row ">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center table-responsive">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Season</th>
                            <th>Ranch</th>
                            <th>Crop Name</th>
                            {/* <th>Quantity</th> */}
                            <th>Assumption </th>
                            <th>Good Yield Rate</th>
                            <th>Bad Yield Rate</th>
                            <th>Discount</th>
                            {/* <th>Currency</th> */}
                            <th>Status</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.createdDate}</td>
                                <td>{x.seasonName}</td>
                                <td>{x.ranchName}</td>
                                <td>{x.cropName}</td>
                                {/* <td>
                                  {x.quantity} {x.unitAbbreviation}
                                </td> */}
                                <td>{x.assessmentValue}</td>
                                <td>{x.goodYieldRate}</td>
                                <td>{x.badYieldRate}</td>
                                <td>{x.discount}</td>
                                {/* <td>
                                  {localStorage.getItem("currencyCode") || ""}
                                </td> */}
                                <td>
                                  {x.status == 1 ? "Active" : "In-Active"}
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    style={{ display: canDelete }}
                                    onClick={(e) =>
                                      handleDelete(e, x.assessmentId)
                                    }
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default BuyBackPriceList;
